import {PropsWithChildren} from 'react';
import {cn} from '@/lib/utils';

type Props = PropsWithChildren & {
  className?: string;
};

export default function InputContainer({className, children}: Props) {
  return <div className={cn('flex flex-col', className)}>{children}</div>;
}
